<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">Configuración de mantenimiento</h1>
    </div>

    <form class="custom-form" @submit.prevent="save" novalidate>
      <b-card tag="article" no-body style="max-width: 640px" class="custom-card">
        <b-card-header header-tag="section" class="custom-card-header d-flex align-items-center">
          <h3>Vehículo {{ plate ? `· ${plate}` : '' }}</h3>
        </b-card-header>
        <b-card-body class="custom-card-body p-0">
          <section class="form-section">
            <p v-if="!exists" class="text-muted small">
              Este vehículo aún no tiene configuración; se muestran los valores por defecto.
            </p>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Intervalo de mantenimiento (km) *</label>
                  <input type="number" min="1" step="1" v-model.number="form.interval_km"
                    class="custom-form-control" placeholder="5000"
                    :class="{ 'custom-form-control-error': $v.form.interval_km.$error }" />
                  <FormError v-if="$v.form.interval_km.$error && !$v.form.interval_km.required"
                    message="El intervalo es requerido" />
                  <FormError v-if="$v.form.interval_km.$error && !$v.form.interval_km.minValue"
                    message="El intervalo debe ser mayor a 0" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Taller de referencia (opcional)</label>
                  <input type="text" v-model="form.workshop_name" class="custom-form-control"
                    placeholder="Nombre del taller" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Teléfono del taller (opcional)</label>
                  <input type="text" v-model="form.workshop_phone" class="custom-form-control"
                    placeholder="Teléfono" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group mb-0">
                  <label>Notas</label>
                  <textarea v-model="form.notes" class="custom-form-control" rows="2"
                    placeholder="Observaciones"></textarea>
                </div>
              </div>
            </div>
          </section>

          <section class="form-section">
            <div class="form-group-buttons text-right">
              <router-link :to="{ name: 'fleet-maintenances' }" class="button button-light">Volver</router-link>
              <button class="button button-primary" type="submit">Guardar</button>
            </div>
          </section>
        </b-card-body>
      </b-card>
    </form>
  </div>
</template>

<script>
import { Alert, FormError } from 'wize-admin'
import { required, minValue } from 'vuelidate/lib/validators'
import { FleetMaintenanceService, VehicleService } from '@/core/services'

export default {
  name: 'MaintenanceConfig',
  components: { FormError },
  data() {
    return {
      exists: false,
      plate: '',
      form: {
        interval_km: 5000,
        workshop_name: null,
        workshop_phone: null,
        notes: null
      }
    }
  },
  validations: {
    form: {
      interval_km: { required, minValue: minValue(1) }
    }
  },
  computed: {
    vehicleId() { return Number(this.$route.params.vehicleId) }
  },
  methods: {
    async save() {
      this.$v.$touch()
      if (this.$v.$error) return
      try {
        await this.$store.dispatch('app/loading', true)
        const payload = {
          interval_km: Number(this.form.interval_km),
          workshop_name: this.form.workshop_name || null,
          workshop_phone: this.form.workshop_phone || null,
          notes: this.form.notes || null
        }
        await FleetMaintenanceService.saveConfig(this.vehicleId, payload)
        Alert.success('Configuración guardada correctamente')
        this.$router.push({ name: 'fleet-maintenances' })
      } catch (e) {
        console.error(e)
        Alert.error(e.errors ? e.errors.message : 'No se pudo guardar la configuración')
      } finally {
        await this.$store.dispatch('app/loading', false)
      }
    },
    async loadConfig() {
      try {
        await this.$store.dispatch('app/loading', true)
        const res = await FleetMaintenanceService.getConfig(this.vehicleId)
        const p = res.payload || {}
        this.exists = !!p.exists
        this.form = {
          interval_km: p.interval_km != null ? p.interval_km : 5000,
          workshop_name: p.workshop_name || null,
          workshop_phone: p.workshop_phone || null,
          notes: p.notes || null
        }
      } catch (e) {
        console.error(e)
        Alert.error(e.errors ? e.errors.message : 'No se pudo cargar la configuración')
        this.$router.push({ name: 'fleet-maintenances' })
      } finally {
        await this.$store.dispatch('app/loading', false)
      }
    },
    async loadPlate() {
      try {
        const res = await VehicleService.get(this.vehicleId)
        this.plate = res.payload ? res.payload.license_plate || '' : ''
      } catch (e) { /* placa es solo informativa */ }
    }
  },
  async created() {
    await this.loadConfig()
    this.loadPlate()
  }
}
</script>
